module.exports = __webpack_public_path__ + "img/logo-yomaro.b423372a.png";